import React from 'react';

const stats = [
	{
		number: "✔",
		label: "Find Tailors You Can Trust",
		desc: "Browse real work, compare styles, and choose with confidence.",
	},
	{
		number: "✔",
		label: "Get Exactly What You Want",
		desc: "Send your fabric or let the tailor source it — your choice.",
	},
	{
		number: "✔",
		label: "No More Guesswork",
		desc: "See updates, approve fabrics, and avoid disappointing results.",
	},
];

export default function Vision() {
  return (
		<section
			style={{
				padding: "100px 24px",
				background: "var(--bg)",
				position: "relative",
				overflow: "hidden",
			}}
		>
			{/* Background glow */}
			<div
				style={{
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "600px",
					height: "400px",
					background:
						"radial-gradient(ellipse, rgba(240,165,0,0.06) 0%, transparent 70%)",
					pointerEvents: "none",
				}}
			/>

			<div
				style={{
					maxWidth: "960px",
					margin: "0 auto",
					position: "relative",
					zIndex: 1,
				}}
			>
				<div style={{textAlign: "center", marginBottom: "64px"}}>
					<p
						style={{
							fontSize: "0.75rem",
							letterSpacing: "0.18em",
							textTransform: "uppercase",
							color: "var(--gold)",
							fontWeight: "500",
							marginBottom: "14px",
						}}
					>
						
					</p>
					<h2
						style={{
							fontFamily: "var(--font-display)",
							fontSize: "clamp(2.2rem, 5vw, 3.6rem)",
							fontWeight: "600",
							color: "#fff",
							lineHeight: "1.15",
							marginBottom: "20px",
						}}
					>
						Custom Clothes,
						<br />
						<span
							style={{color: "var(--gold)", fontStyle: "italic"}}
						>
							Without The Stress.
						</span>
					</h2>
					<p
						style={{
							color: "var(--text-muted)",
							fontSize: "1.05rem",
							maxWidth: "500px",
							margin: "0 auto",
						}}
					>
						Find skilled tailors, choose your style, and get your
						outfit made your way — without the usual stress.
					</p>
				</div>

				{/* Stat cards */}
				<div
					style={{
						display: "grid",
						gridTemplateColumns:
							"repeat(auto-fit, minmax(260px, 1fr))",
						gap: "20px",
						marginBottom: "60px",
					}}
				>
					{stats.map((s, i) => (
						<div
							key={i}
							style={{
								background: "var(--surface)",
								border: "1px solid var(--border)",
								borderRadius: "16px",
								padding: "32px 28px",
								transition: "border-color 0.3s, transform 0.3s",
							}}
							onMouseEnter={(e) => {
								e.currentTarget.style.borderColor =
									"rgba(240,165,0,0.4)";
								e.currentTarget.style.transform =
									"translateY(-4px)";
							}}
							onMouseLeave={(e) => {
								e.currentTarget.style.borderColor =
									"var(--border)";
								e.currentTarget.style.transform =
									"translateY(0)";
							}}
						>
							<div
								style={{
									fontFamily: "var(--font-bold)",
									fontSize: "3.2rem",
									color: "var(--gold)",
									lineHeight: 1,
									marginBottom: "8px",
									letterSpacing: "0.04em",
								}}
							>
								{s.number}
							</div>
							<div
								style={{
									fontWeight: "600",
									fontSize: "0.95rem",
									color: "#fff",
									marginBottom: "10px",
								}}
							>
								{s.label}
							</div>
							<p
								style={{
									color: "var(--text-muted)",
									fontSize: "0.875rem",
									lineHeight: "1.6",
								}}
							>
								{s.desc}
							</p>
						</div>
					))}
				</div>

				{/* Quote / statement */}
				<div
					style={{
						background:
							"linear-gradient(135deg, rgba(240,165,0,0.08) 0%, rgba(240,165,0,0.03) 100%)",
						border: "1px solid rgba(240,165,0,0.2)",
						borderRadius: "16px",
						padding: "40px",
						textAlign: "center",
					}}
				>
					<div style={{fontSize: "2rem", marginBottom: "16px"}}>
					</div>
					<p
						style={{
							fontFamily: "var(--font-display)",
							fontSize: "clamp(1.2rem, 2.5vw, 1.7rem)",
							fontStyle: "italic",
							fontWeight: "300",
							color: "rgba(255,255,255,0.85)",
							lineHeight: "1.5",
							maxWidth: "600px",
							margin: "0 auto 16px",
						}}
					>
						"You deserve clothes that actually fit your vision."
					</p>
					<p
						style={{
							color: "var(--gold)",
							fontSize: "0.85rem",
							fontWeight: "500",
						}}
					>
						— The Kaftora Team
					</p>
				</div>
			</div>
		</section>
  );
}
